module.exports = __webpack_public_path__ + "static/media/cm.4982702b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cm.svg
// module id = 1208
// module chunks = 0